// components/Process.jsx
import React from 'react';

const steps = [
  { num: '1', title: 'Book a Test', desc: 'Call us, walk in, or fill the form online to schedule your test at a time that suits you.' },
  { num: '2', title: 'Sample Collection', desc: 'Visit our center or opt for home collection. Our phlebotomists ensure a safe, painless experience.' },
  { num: '3', title: 'Lab Processing', desc: 'Samples are processed in our fully equipped laboratory using certified procedures and equipment.' },
  { num: '4', title: 'Receive Report', desc: 'Get your digital report on WhatsApp or email within the promised timeframe — or collect from center.' }
];

const Process = () => {
  return (
    <section id="process" className="py-20 px-8 bg-cream">
      <div className="max-w-[1200px] mx-auto">
        <p className="text-teal text-[0.75rem] font-semibold tracking-[2px] uppercase mb-3">Simple Process</p>
        <h2 className="text-4xl md:text-5xl text-charcoal font-serif mb-4">How It Works</h2>
        <p className="text-[#5a7a77] max-w-md leading-relaxed">Getting tested at SRM Diagnostic Center is quick, easy, and stress-free.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-0 mt-12 relative">
          {steps.map((step, idx) => (
            <div key={idx} className="text-center p-8 relative">
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute right-[-10px] top-1/2 -translate-y-1/2 text-[#b2d9d4] text-2xl">→</div>
              )}
              <div className="w-16 h-16 bg-teal rounded-full flex items-center justify-center mx-auto mb-5 text-white text-xl font-serif">{step.num}</div>
              <h3 className="text-charcoal text-base mb-1.5">{step.title}</h3>
              <p className="text-[#6b8a87] text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;